import { FormControl, Input } from "@chakra-ui/react";

export const OtherSupplierInput = ({register, errors, required, name}) => {
    return(
        <FormControl mb="1rem" isInvalid={!!errors[name]}>
            <Input {...register(name, {required})} placeholder="Specify other supplier" id="other_supplier" />
        </FormControl>
    )
}
